import { z } from 'zod';
export const healthResponseSchema = z.object({
    status: z.literal('ok'),
    version: z.string(),
    database: z.enum(['ok', 'unreachable']),
    timestamp: z.iso.datetime({ offset: true }),
});
export * from './common.js';
export * from './property.js';
export * from './loan.js';
export * from './reference.js';
export * from './simulation.js';
export * from './ingestion.js';
export * from './assignment.js';
export * from './ledger.js';
export * from './auth.js';
export * from './forecast.js';
export * from './market.js';
export * from './sector.js';
//# sourceMappingURL=index.js.map